<table class="table-condensed w-100 border-table position-relative" [ngClass]="{ 'margin-without-price': !displayPrice && allowAdding}">
  <thead class="bg-light border-bottom-table">
  <tr>
    <th class="px-2 w-10-px position-sticky top-45 z-index-100" i18n="@@app.copy" [ngClass]="{'top-53' : increaseTopStickyPosition}">Copy</th>
    <th class="px-2 w-20-px position-sticky top-45 z-index-100" i18n="@@app.image" [ngClass]="{'top-53' : increaseTopStickyPosition}">Image</th>
    <th class="cursor-pointer w-120-px text-left position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.REFERENCE)">
      <ng-container i18n="@@app.reference">Reference</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.REFERENCE:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.REFERENCE:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th class="cursor-pointer w-130-px text-left position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.ENUMBER)">
      <ng-container i18n="@@app.e_number">E-number</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.ENUMBER:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.ENUMBER:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th class="cursor-pointer text-left position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.DESCRIPTION)">
      <ng-container i18n="@@app.description">Description</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.DESCRIPTION:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.DESCRIPTION:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th [hidden]="!displayPrice" class="cursor-pointer w-130-px text-right position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.UNIT_PRICE)">
      <ng-container i18n="@@app.unit_price">Unit price</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.UNIT_PRICE:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down opposite-m arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.UNIT_PRICE:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th class="cursor-pointer w-105-px position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.QUANTITY)">
      <ng-container class="pl-15" i18n="@@app.quantity">Quantity</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.QUANTITY:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.QUANTITY:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th class="cursor-pointer w-140-px position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.DIRECT_DELIVERY)">
      <ng-container i18n="@@app.direct_delivery">Direct Delivery</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.DIRECT_DELIVERY:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down opposite-m arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.DIRECT_DELIVERY:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th class="cursor-pointer w-140-px position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.PREWIRING)">
      <ng-container i18n="@@app.prewiring">Prewiring</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.PREWIRING:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down opposite-m arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.PREWIRING:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    <th class="cursor-pointer w-170-px text-right position-sticky top-45 z-index-101" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.STOCK_LEVEL)">
            <span class="ml-1 color-icon-gray float-right">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.STOCK_LEVEL:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down opposite-m arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.STOCK_LEVEL:tableSortSequence.DESCENDING)}"></i>
      </span>
      <div class="tooltip cursor-pointer float-right position-initial mx-1">
        <span class="cheatSheetIcon se-icon-information_stroke info-icon no-line-height font-size-18 cursor-pointer"></span>
        <span class="tooltip-text tooltip-right w-75 text-left font-size-xs position-absolute px-2 py-1">
          <ng-container i18n="@@app.stock_availability_info">Freely available quantity in the central warehouse of Schneider Electric. Quantities are indicative and may change again regularly.</ng-container>
        </span>
      </div>
      <div class="float-right d-inline-block align-middle">
        <ng-container i18n="@@app.stock_level">Stock Level</ng-container>
      </div>
    </th>
    <th [hidden]="!displayPrice" class="cursor-pointer w-115-px text-right position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" (click)="onSortDevices(headerNames.TOTAL_PRICE)">
      <ng-container i18n="@@app.total_price">Total Price</ng-container>
      <span class="ml-1 color-icon-gray">
        <i class="icon-12 se-icon-arrow3_up arrow-up-top cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.TOTAL_PRICE:tableSortSequence.ASCENDING)}"></i>
        <i class="icon-12 se-icon-arrow3_down opposite-m arrow-down-right cursor-pointer" [ngClass]="{'activeSortHeader': (sortSelection | indicateSort:headerNames.TOTAL_PRICE:tableSortSequence.DESCENDING)}"></i>
      </span>
    </th>
    @if (allowAdding) {
      <th class="w-60-px text-center position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}" i18n="@@app.action">Action</th>
    }
    @if (!allowAdding) {
      <th class="w-60-px text-center position-sticky top-45 z-index-100" [ngClass]="{'top-53' : increaseTopStickyPosition}"></th>
    }
  </tr>
  </thead>
  <tbody>
  <!-- TODO: Convert *ngFor to @for after verifying trackByIndex function signature and testing -->
  <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
  <ng-container *ngFor="let bomModel of bomModels;trackBy:trackByIndex let i = index" >
    <tr class="border-bottom-table"
        [ngClass]="{'text-color-medium-gray': !(bomModel | isStatusActive)}" #tr>
      <td [ngClass]="{'opacity-6': !(bomModel | isStatusActive)}">
        <div class="custom-control custom-checkbox">
          <input id="{{bomModel?.article?.id | generateBomRadioButtonId: isAccessoriesModel: isProjectComponentsModel}}" class="cursor-pointer custom-control-input" type="checkbox" [disabled]="!(bomModel | isStatusActive)"
                 [checked]="(selectedItems | selectCheckbox : bomModel?.article?.id) && (bomModel | isStatusActive)" (change)="toggleSelection(bomModel);">
          <label for="{{bomModel?.article?.id | generateBomRadioButtonId: isAccessoriesModel: isProjectComponentsModel}}" class="custom-control-label"></label>
        </div>
      </td>
      <td class="image-cell text-center">
        <app-ui-image [src]="bomModel?.article?.ref | catalogProductImage:bomModel?.article?.isNxsDummy:bomModel?.article?.isCustomDevice | async" [alt]="bomModel?.article?.ref"
                      [height]="40"></app-ui-image>
      </td>
      <td class="text-left">
        <div class="d-flex align-items-center">
          <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
          <ng-container *ngIf="bomModel?.article | bomPdfIconEnabled else disabledPdf">
            <a
              (click)="downloadDataSheet(bomModel?.article?.ref)"
              [href]="bomModel?.article?.productCharacteristicsLink | productInfoDocumentLink :currentLanguage"
              target="_blank">
              <i title="Datasheet" i18n-title="@@app.datasheet" class="icon20 se-icon-action_pdf_report red align-top pb-1"></i>
            </a>
          </ng-container>
          <ng-template #disabledPdf>
            <i title="Datasheet" i18n-title="@@app.datasheet" class="icon20 se-icon-action_pdf_report text-color-medium-gray align-top pb-1"></i>
          </ng-template>
          <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
          <ng-container *ngIf="bomModel?.article?.productInfoLink else withoutLink">
            <a
              class="color-inherit"
              [href]="bomModel?.article?.ref | linkToSchneiderProduct :currentLanguage"
              target="_blank">
              {{ bomModel?.article?.ref }}
            </a>
          </ng-container>
          <ng-template #withoutLink>
            <span class="cursor-default">
              {{ bomModel?.article?.ref }}
            </span>
          </ng-template>
        </div>
      </td>
      <td class="text-left">
        {{ bomModel?.article?.eNumber !== 0 ? bomModel?.article?.eNumber : '' }}
      </td>
      <td class="text-left">
        {{ bomModel?.article?.description }}
      </td>
      <td [hidden]="!displayPrice" class="text-right" [ngClass]="{'strike-out-price': !(bomModel | isStatusActive)}">
        <!-- TODO: Convert to @if with 'as' pattern after verifying variable scoping in nested blocks -->
        <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
        <ng-container *ngIf="bomModel?.article?.priceBeforeDiscount as priceBeforeDiscount"><span class="strike-out-price pr-1">{{priceBeforeDiscount | number:'1.2-2':'de-CH'}}</span></ng-container>
        @if (bomModel?.article?.price > 0) {
          <span [ngClass]="{'text-color-brand' : bomModel?.article?.priceBeforeDiscount }">{{bomModel?.article?.price | number:'1.2-2':'de-CH'}}</span>
        } @else {
          <div i18n="@@app.not_defined">N/D</div>
        }
      </td>
      <td [ngClass]="{'pointer-events-none opacity-6': !isEditableProject}">
        <app-ui-article-counter
          [quantityChangeable]="quantityChangeable"
          [tableIdentifier]="tableIdentifier"
          [counter]="bomModel?.quantity"
          [status]="bomModel?.article?.status"
          [apartmentsCount]="selectedApartments?.length | minimumCountOne"
          (quantityDecrease)="onDecreaseQuantity($event, bomModel)"
          (quantityChanged)="onQuantityChange(tr)"
          (quantityIncrease)="onIncreaseQuantity($event, bomModel)">
        </app-ui-article-counter>
      </td>
      <td class="text-center" [ngClass]="{'opacity-6': !(bomModel | isStatusActive), 'pointer-events-none opacity-6': !isEditableProject}">
        <app-ui-bom-radio-delivery-options
          appDisableMultipleClickWithNoneEvent
          [isChecked]="bomModel?.article?.deliverToCustomer && (bomModel | isStatusActive)"
          [deliveryDisabled]="deliveryDisabled"
          [isDirectDelivery]="true"
          (changed)="deliveryChanged(bomModel, $event, tableIdentifier)"
        >
        </app-ui-bom-radio-delivery-options>
      </td>
      <td class="text-center" [ngClass]="{'opacity-6': !(bomModel | isStatusActive), 'pointer-events-none opacity-6': !isEditableProject}">
        <app-ui-bom-radio-delivery-options
          appDisableMultipleClickWithNoneEvent
          [isChecked]="bomModel?.article?.deliverToPanelBuilder && (bomModel | isStatusActive)"
          [deliveryDisabled]="deliveryDisabled"
          [isDirectDelivery]="false"
          (changed)="deliveryChanged(bomModel, $event, tableIdentifier)"
        >
        </app-ui-bom-radio-delivery-options>
      </td>
      <td class="text-right">
        <app-bom-stock-level [stockLevel]="bomModel?.article?.stockLevel"></app-bom-stock-level>
      </td>
      <td [hidden]="!displayPrice" class="text-right" [ngClass]="{'strike-out-price': !(bomModel | isStatusActive)}">
        @if (bomModel?.article?.price > 0) {
          {{(bomModel?.article?.price * (bomModel?.quantity | countQuantityBomTable:selectedApartments)) | number:'1.2-2':'de-CH'}}
        } @else {
          <div i18n="@@app.not_defined">N/D</div>
        }
        @if (discountEnabled) {
          <div class="text-color-brand">{{bomModel?.article?.price * bomModel?.quantity | totalPrice:null:discount:discountEnabled | number:'1.2-2':'de-CH'}}</div>
        }
      </td>
      @if (allowAdding) {
        <td class="text-center" [ngClass]="{'pointer-events-none opacity-6': !isEditableProject}">
          <i appDisableMultipleClickWithNoneEvent class="icon24 se-icon-action_delete iconFontSize color-black delete-icon" (click)="onDeleteBomItem(bomModel)"></i>
        </td>
      }
      @if (!allowAdding) {
        <td class="text-center"></td>
      }
    </tr>
  <!-- TODO: Convert to @if with 'as' pattern after verifying variable scoping in nested blocks -->
  <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
  <ng-container *ngIf="bomModel?.article?.replacingProduct as replacingProduct">
    <tr class="border-bottom-table"
        [ngClass]="{'text-color-medium-gray': !(bomModel | isStatusActive)}" #tr>
      <td>
        <div class="display-flex">
          <img class="arrow-right substitution-arrow"
               src="/assets/images/arrow-sub-down-right.svg" alt="Sub device">
          <div class="tooltip z-index-10 replacing-product-info cursor-pointer float-right position-initial mt-1">
            <span class="cheatSheetIcon se-icon-information_stroke info-icon no-line-height font-size-18 cursor-pointer"></span>
            <span class="tooltip-text tooltip-right tooltip-replacing-info-text text-left font-size-xs position-absolute px-2 py-1">
            <ng-container i18n="@@app.project_substitution_info">As soon as the upper product is no longer available, only this new version is displayed. This new reference can be added in the parts list under "Other Components".</ng-container>
          </span>
          </div>
        </div>
      </td>
      <td class="image-cell text-center">
        <app-ui-image [src]="replacingProduct.ref | catalogProductImage:false | async" [alt]="replacingProduct.ref"
                      [height]="40"></app-ui-image>
      </td>
      <td class="text-left">
        <div class="d-flex align-items-center">
          <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
          <ng-container *ngIf="bomModel?.article | bomPdfIconEnabled else disabledPdf">
            <a
              [href]="replacingProduct.productCharacteristicsLink | productInfoDocumentLink :currentLanguage"
              target="_blank">
              <i title="Datasheet" i18n-title="@@app.datasheet" class="icon20 se-icon-action_pdf_report red align-top pb-1"></i>
            </a>
          </ng-container>
          <ng-template #disabledPdf>
            <i title="Datasheet" i18n-title="@@app.datasheet" class="icon20 se-icon-action_pdf_report text-color-medium-gray align-top pb-1"></i>
          </ng-template>
          {{ replacingProduct.ref }}
        </div>
      </td>
      <td class="text-left">
        {{ replacingProduct.eNumber !== 0 ? replacingProduct.eNumber : '' }}
      </td>
      <td class="text-left">
        {{ replacingProduct.description }}
      </td>
      <td [hidden]="!displayPrice" class="text-right">
        <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
        <ng-container *ngIf="replacingProduct.price > 0; else noPrice">{{replacingProduct.price | number:'1.2-2':'de-CH'}}</ng-container>
        <ng-template #noPrice><div i18n="@@app.not_defined">N/D</div></ng-template>
      </td>
      <td></td>
      <td>
      </td>
      <td></td>
      <td class="text-right">
        <app-bom-stock-level [stockLevel]="replacingProduct?.stockLevel"></app-bom-stock-level>
      </td>
      <td [hidden]="!displayPrice" class="text-right">
        @if (replacingProduct.price > 0) {
          {{(replacingProduct.price * (bomModel?.quantity | countQuantityBomTable:selectedApartments)) | number:'1.2-2':'de-CH'}}
        } @else {
          <div i18n="@@app.not_defined">N/D</div>
        }
        @if (discountEnabled) {
          <div class="text-color-brand">{{replacingProduct.price * bomModel?.quantity | totalPrice:null:discount:discountEnabled | number:'1.2-2':'de-CH'}}</div>
        }
      </td>
      @if (allowAdding) {
        <td class="text-center" [ngClass]="{'pointer-events-none opacity-6': !isEditableProject}">
          <i appDisableMultipleClickWithNoneEvent class="icon24 se-icon-action_delete iconFontSize color-black" (click)="onDeleteBomItem(bomModel)"></i>
        </td>
      }
      @if (!allowAdding) {
        <td class="text-center"></td>
      }
    </tr>
  </ng-container>
  </ng-container>
  <!-- TODO: Convert to @if with else pattern after refactoring ngTemplate fallback -->
  <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
  <ng-container *ngIf="!bomModels?.length">
    <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
    <tr *ngIf="!allowAdding || (allowAdding && !isEditableProject)">
      <td colspan="11">
        <!-- TODO: Convert to @if/@else after refactoring ngTemplate loading fallback -->
        <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
        <ng-container *ngIf="bomModels?.length === 0; else loadingBlock">
          <p i18n="@@app.nothing_to_show">Nothing to show</p>
        </ng-container>
        <ng-template #loadingBlock>
          <app-ui-loading [minHeight]="200"></app-ui-loading>
        </ng-template>
      </td>
    </tr>
  </ng-container>
  @if (allowAdding && isEditableProject) {
    <tr [ngClass]="{'border-bottom': (!referenceFieldInvalid && !enumberFieldInvalid && !isEnumberFieldStartWithIncorrectNumber), 'pointer-events-none opacity-6': !isEditableProject}">
    <td>
      <div class="custom-control custom-checkbox">
        <input #newAccessoriesProductSelected id="accessories" class="cursor-pointer custom-control-input" type="checkbox" [checked]="true">
        <label for="accessories" class="custom-control-label"></label>
      </div>
    </td>
    <td>
      <img [src]="deviceImages.DEFAULT_IMAGE" alt="">
    </td>
    <td>
      <div class="ng-autocomplete">
        <app-autocomplete-dropdown #autoReference
                                   [data]="productsWithLimit"
                                   [searchKeyword]="keywordReference"
                                   [titleProperty]="'pDescription'"
                                   placeHolder="Reference"
                                   i18n-placeHolder="@@app.reference"
                                   (selected)='onReferenceAdd($event)'
                                   (inputChanged)="onSearchProductsByReference($event)"
                                   (closed)="onClosedAutocomplete()"
                                   (focusOut)="addProductOnFocusOut('reference')"
                                   (keyupEnter)="addProductOnKeyupEnter('reference')"
                                   (inputCleared)="onInputClearedReference()"
                                   [itemTemplate]="itemTemplate"
                                   [notFoundTemplate]="notFoundTemplate">
        </app-autocomplete-dropdown>
        <ng-template #itemTemplate let-item>
          <a [innerHTML]="item.reference"></a>
        </ng-template>
        <ng-template #notFoundTemplate let-notFound>
          <div [innerHTML]="notFound"></div>
        </ng-template>
      </div>
    </td>
    <td>
      <div class="ng-autocomplete">
        <app-autocomplete-dropdown #autoEnumber
                                   [data]="productsWithLimit"
                                   [titleProperty]="'pDescription'"
                                   [searchKeyword]="keywordEnumber"
                                   [maxLength]="9"
                                   placeHolder="E-number"
                                   i18n-placeHolder="@@app.e_number"
                                   (selected)='onReferenceAdd($event)'
                                   (inputChanged)="onSearchProductsByEnumber($event)"
                                   (closed)="onClosedAutocomplete()"
                                   (focusOut)="addProductOnFocusOut('enumber')"
                                   (keyupEnter)="addProductOnKeyupEnter('enumber')"
                                   (inputCleared)="onInputClearedEnumber()"
                                   [itemTemplate]="itemTemplateEnumber"
                                   [notFoundTemplate]="notFoundTemplateEnumber">
        </app-autocomplete-dropdown>
        <ng-template #itemTemplateEnumber let-item>
          <a [innerHTML]="item.enumber"></a>
        </ng-template>
        <ng-template #notFoundTemplateEnumber let-notFound>
          <div [innerHTML]="notFound"></div>
        </ng-template>
      </div>
    </td>
    <td>
      <input #descriptionInput class="form-control" i18n-placeholder="@@app.description" placeholder="Description"/>
    </td>
    <td [hidden]="!displayPrice">
      <input #unitPriceInput type="number" min="0" class="form-control" i18n-placeholder="@@app.unit_price" placeholder="Unit Price"/>
    </td>
    <td>
      <app-ui-article-counter
        [quantityChangeable]="quantityChangeable"
        [counter]="quantity"
        [apartmentsCount]="tableIdentifier === tableIdentifiers?.PROJECT_COMPONENTS ? 1 : selectedApartments?.length"
        [status]="activeStatus"
        (quantityDecrease)="customProductQuantityDecrease()"
        (quantityIncrease)="customProductQuantityIncrease()">
      </app-ui-article-counter>
    </td>
    <td class="text-center">
      <app-ui-bom-radio-delivery-options
        [isChecked]="accessoriesDeliveryDirectRadio"
        [deliveryDisabled]="deliveryDisabled"
        [isDirectDelivery]="true"
        (changed)="toggleRadioSelectionForDeliveryInNewAccessory($event)"
      >
      </app-ui-bom-radio-delivery-options>
    </td>
    <td class="text-center">
      <app-ui-bom-radio-delivery-options
        [isChecked]="!accessoriesDeliveryDirectRadio"
        [deliveryDisabled]="deliveryDisabled"
        [isDirectDelivery]="false"
        (changed)="toggleRadioSelectionForDeliveryInNewAccessory($event)"
      >
      </app-ui-bom-radio-delivery-options>
    </td>
    <td></td>
    <td [hidden]="!displayPrice" class="text-color-grey text-right" i18n="@@app.total_price">Total Price</td>
    <td class="text-center">
      @if (isAddButtonVisible) {
        <img class="cursor-pointer"
             [ngClass]="{'pointer-events-none opacity-6': (enumberFieldInvalid || referenceFieldInvalid || isEnumberFieldStartWithIncorrectNumber)}"
             alt=""
             src="/assets/images/new_mid_black_icon.svg"
             i18n-title="@@app.add_custom_product"
             title="Add custom product" (click)="addCustomProduct()">
      }
    </td>
  </tr>
  }
  @if (allowAdding && (enumberFieldInvalid || referenceFieldInvalid || isEnumberFieldStartWithIncorrectNumber)) {
    <tr class="border-bottom">
    <td></td>
    <td></td>
    <td colspan="2">
      @if (referenceFieldInvalid) {
        <span class="invalid-feedback d-block font-size-10 w-100">
          <ng-container i18n="@@app.error_reference_length">Reference must be between 2 and 20 characters</ng-container>
        </span>
      }
      @if (enumberFieldInvalid) {
        <span class="invalid-feedback d-block font-size-10 w-100">
          <ng-container i18n="@@app.error_enumber_length">Enumber must accept 9 digit</ng-container>
        </span>
      }
      @if (isEnumberFieldStartWithIncorrectNumber) {
        <span class="invalid-feedback d-block font-size-10 w-100">
          <ng-container i18n="@@app.error_enumber_cannot_start">Enumber cannot start with number 0</ng-container>
        </span>
      }
    </td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  }
  @if (priceSummaryEnabled && bomModels?.length !== 0 && displayPrice) {
    <tr class="border-bottom">
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td [hidden]="!displayPrice" colspan="2" class="total-price text-right">
      <ng-container i18n="@@app.total_price">Total Price</ng-container>: {{ priceSummary | currency: currency: 'symbol': undefined: 'de-CH' }}
    </td>
    <td></td>
  </tr>
  }
  </tbody>
</table>
@if (displayTotalPrice && displayPrice) {
  <div class="total-price-area">
  <div class="mt-2 bg-light">
    <app-ui-bom-discount [discountOnPrice]="0"
                         [discountEnabled]="false"
                         [totalPrice]="priceWithoutVatTotal"></app-ui-bom-discount>
  </div>
  <div class="text-right pt-1 font-italic">*<ng-container i18n="@@app.api.documents.price_subject_to_change">Prices subject to change.</ng-container></div>
</div>
}
